var DEFAULTS={config:{alignment:"center",size:"content"},configViewer:{downloadTarget:"_blank"}};export{DEFAULTS};
//# sourceMappingURL=defaults.js.map
